import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
// Modals
import { AlertasModales } from '../../../helpers/alertasModales';
// Servicios
import { RutasService } from '../../../services/rutas.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { RegionesService } from '../../../services/regiones.service';

const ID_PAGINA = 30;

@Component({
  selector: 'app-ruta',
  templateUrl: './ruta.component.html',
  styleUrls: ['./ruta.component.css']
})
export class RutaComponent implements OnInit {
  form: FormGroup;
  requerirAprobacion = false;
  regiones = [];
  subRegiones = [];
  constructor( private rutaService: RutasService,
               private empleadoService: EmpleadosServicio,
               private router: Router,
               private modals: AlertasModales,
               private regionesService: RegionesService) {
      if (empleadoService.datosEmpleado.tipo_empleado !== 3 &&
          !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA === ID_PAGINA).length) {
                        this.router.navigate(['/404']);
        }
    this.form = new FormGroup({
      'nombreRuta': new FormControl('', Validators.required),
      'cobro_meta': new FormControl(''),
      'codigoRuta': new FormControl(''),
      'descripcionRuta': new FormControl(''),
      'requiere_aprobacion': new FormControl(''),
      'requiere_aprobacion_monto': new FormControl({value: '', disabled: true}),
      'ID_REGION': new FormControl(''),
      'ID_SUB_REGION': new FormControl('')
    });
    const subcription = this.regionesService.regiones().subscribe( regiones => {
      this.regiones = regiones;
      subcription.unsubscribe();
    });
  }

  ngOnInit() {
    this.initSubRegiones();
  }

  initSubRegiones() {
    this.form.get('ID_REGION').valueChanges.subscribe(value => {
      if (value) {
        this.loadSubRegiones(value);
      } else {
        this.form.get('ID_SUB_REGION').setValue('');
        this.subRegiones = [];
      }
    });

  }

  loadSubRegiones(ID_REGION) {
   const subcription = this.regionesService.subRegiones(ID_REGION)
    .subscribe(result => {
      this.subRegiones = result;
      subcription.unsubscribe();
    });
  }
  asignarRequired() {
    if (this.requerirAprobacion) {
      this.form.controls['requiere_aprobacion_monto'].disable();
    } else {
      this.form.controls['requiere_aprobacion_monto'].enable();
    }

    this.requerirAprobacion = !this.requerirAprobacion;

    if (this.form.get('requiere_aprobacion').value) {

      this.form.get('requiere_aprobacion_monto').setValidators(Validators.required);
      this.form.get('requiere_aprobacion_monto').updateValueAndValidity();
    } else {
      this.form.get('requiere_aprobacion_monto').clearValidators();
      this.form.get('requiere_aprobacion_monto').updateValueAndValidity();
    }
  }

  guardarRuta() {
    if (this.form.valid) {
     this.rutaService.crearRuta(this.form.value).subscribe(res => {
       if (res) {
        this.modals.correctoModalJquery('Ruta creada con éxito', 'green', 'modern', 'fa fa-upload fa-map');
        this.form.reset({ID_EMPLEADO: this.empleadoService.datosEmpleado.ID_EMPLEADO});
        this.form.get('requiere_aprobacion_monto').clearValidators();
        this.form.get('requiere_aprobacion_monto').updateValueAndValidity();
       }
     }, err => {
        if (err) {
          this.modals.validacionesModalJquery('Aviso', err.error, 'orange', 'light', false, 'fa fa-info-circle');
        }
     });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/rutas/nueva/ruta.component.ts